import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface User {
  _id: string
  email: string
  given_name: string
  family_name: string
  phone?: string
  avatar?: string
  signature?: string
  privileges?: string[]
  division?: string
  agent_is_in_queue?: boolean
  agent_current_call?: string | null
  agent_can_receive_calls?: boolean
  settings?: {
    optimize_performance?: "off" | "full"
    hide_pdf_annotations?: boolean
  }
  matter_settings?: {
    show_only_my_items?: boolean
  }
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isInitialized: boolean // true once we've checked auth status
  setAuth: (user: User, token: string) => void
  clearAuth: () => void
  setInitialized: () => void
  updateUser: (updates: Partial<User>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isInitialized: false,
      setAuth: (user, token) =>
        set({ user, token, isAuthenticated: true, isInitialized: true }),
      clearAuth: () =>
        set({ user: null, token: null, isAuthenticated: false, isInitialized: true }),
      setInitialized: () =>
        set({ isInitialized: true }),
      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ token: state.token }),
    }
  )
)
